import styled from '@emotion/styled'

export const GreenBlock = styled('div')({
  backgroundColor: '#eaf3e2',
  padding: '1.625rem'
})

export const GrayBlock = styled('div')({
  backgroundColor: 'rgb(229, 229, 229)',
  padding: '1.625rem'
})

export const Title = styled('label')({
  fontWeight: 'bold',
  fontSize: '1rem',
  color: '#166534',
  display: 'block',
  marginBottom: '.5rem'
})

export const List = styled('ul')({
  paddingLeft: '.75rem',
  margin: '.5rem 0 0',
  listStyleType: 'disc !important'
})

export const OrderedList = styled('ol')({
  paddingLeft: '1rem',
  margin: '.5rem 0 0',
  listStyleType: 'decimal !important'
})

export const ListItem = styled('li')({
  lineHeight: '1.5rem',
  fontSize: '.875rem',
  marginTop: '.625rem'
})

export const Paragraph = styled('p')({
  fontSize: '.875rem',
  lineHeight: '1.5rem',
  color: 'rgb(0, 0, 0)',
  marginTop: '.5rem'
})

export const Section = styled('div')({
  marginBottom: '1rem'
})
